<template>
  <div id="zzz" class="home">
      <div style="padding-top:100px;">        
        <div class="">
          <div style="padding-bottom:100px;">
            <div style="width:100%;text-align:center;">
              <h2 style="margin-top:20px;">CAD的人力咨询解决方案</h2>
              <el-row type="flex" justify="space-around">
                  <el-col :span="8">
                      <img src="../assets/images/gg1.png" alt="" srcset="" class="item-image">
                      <div>
                          <div class="title">建模Model</div>
                          <div class="subtitle">胜任力模型</div>
                          <div class="subtitle">领导力模型</div>
                          <div class="subtitle">结构化面试题库</div>
                      </div>
                  </el-col>
                  <el-col :span="8">
                      <img src="../assets/images/gg2.png" alt="" srcset="" class="item-image">
                      <div>
                          <div class="title">测评Assessment</div>
                          <div class="subtitle">360领导力测评</div>
                          <div class="subtitle">DISC/MBTI/九型性格测评</div>
                          <div class="subtitle">领导能力测评</div>
                          <div class="subtitle">情景模拟测评</div>
                          <div class="subtitle">无领导小组</div>
                      </div>
                  </el-col>
                  <el-col :span="8">
                      <img src="../assets/images/gg3.png" alt="" srcset="" class="item-image">
                      <div>
                          <div class="title">培养Development</div>
                          <div class="subtitle">培训体系搭建</div>
                          <div class="subtitle">领导力梯队建设</div>
                          <div class="subtitle">管理干部培养体系</div>
                          <div class="subtitle">人才盘点</div>
                          <div class="subtitle">关键人才继任计划</div>
                      </div>
                  </el-col>
              </el-row>
            </div>                        
          </div>          
        </div>
      </div>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import helpers from '../helper'
export default {
  name:'zzz',
  data(){
    return {
      lists:[]
    }
  },
  methods:{
     
  },
  mounted(){
    
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.item-image{
    width: 30%;
}
.main-container {
  margin: 0 100px;
  -width: 100%;
}
.title{
	font-size: 18px;
	color:#05A4C2;
	font-weight: bold;
	margin-bottom: 20px;
}
.subtitle{
	font-size:14px;line-height:28px;text-align:center;
}
</style>
